<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">Auswertung</h6>
          </div>

          <div class="element-box overflow-hidden">

            <!---------- CUSTOMER ANALYSIS ------------>
            <div v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' ">

              <h5 class="element-header">Kundenauswertung</h5>

              <!--- Customer Overview --->
              <div class="pl-4">
                <h6>Kundenübersicht:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div
                      v-if="companySettings.privateCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12 ">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedPrivateCoachingList'}">
                      Einzelcoaching
                    </router-link>
                  </div>
                  <div
                      v-if="companySettings.groupCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedGroupCoachingList'}">
                      Gruppenmaßnahmen
                    </router-link>
                  </div>
                  <div
                      v-if="companySettings.socioTherapyCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedSocioTherapyCoachingList'}">
                      Soziotherapie
                    </router-link>
                  </div>
                  <div
                      v-if="companySettings.assistedLivingCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedAssistedLivingCoachingList'}">
                      Betreutes Wohnen
                    </router-link>
                  </div>
                  <div
                      v-if="companySettings.companyKey === 'BSG'"
                      class="col-lg-3 col-md-4 col-sm-12">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedOccupationalTherapyCoachingList'}">
                      Ergotherapie
                    </router-link>
                  </div>
                  <div
                      v-if="companySettings.companyKey === 'BSG'"
                      class="col-lg-3 col-md-4 col-sm-12">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedJobCoachingList'}">
                      Jobcoaching AP
                    </router-link>
                  </div>
                  <div
                      v-if="companySettings.caseManagementCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedCaseManagementCoachingList'}">
                      DRV Fallmanagement
                    </router-link>
                  </div>
                  <div
                      v-if="companySettings.privateLearningCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedPrivateLearningCoachingList'}">
                      Private Weiterbildung
                    </router-link>
                  </div>
                </div>
              </div>


              <!--- Detailed analysis --->
              <div class="pl-4 mt-4 pt-3" style="border-top: 1px solid #D8D8D8">
                <h6>Detailauswertung:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div class="col">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnemployedDetailsOverviewList'}">
                      Detailauswertung
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!---------- COACH ANALYSIS ------------>
            <div v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' ">

              <h5 class="element-header mt-5">Coachauswertung</h5>

              <div class="pl-4"
                   v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' ">
                <h6>Coachübersicht:</h6>
                <div class="row">
                  <div class="col">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachOverview'}">
                      Coachübersicht
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="pl-4 mt-4 pt-3" style="border-top: 1px solid #D8D8D8">
                <h6>Coach-Terminauswertung:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.privateCoachingEnabled && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationPrivateCoaching'}">
                      Einzelcoaching
                    </router-link>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.groupCoachingEnabled && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationGroupCoaching'}">
                      Gruppenmaßnahmen
                    </router-link>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.socioTherapyCoachingEnabled && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationSocioTherapyCoaching'}">
                      Soziotherapie
                    </router-link>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.assistedLivingCoachingEnabled && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationAssistedLivingCoaching'}">
                      Betreutes Wohnen
                    </router-link>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.companyKey === 'BSG' && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationOccupationalTherapyCoaching'}">
                      Ergotherapie
                    </router-link>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.companyKey === 'BSG' && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationJobCoaching'}">
                      Jobcoaching AP
                    </router-link>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.caseManagementCoachingEnabled && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationCaseManagementCoaching'}">
                      DRV Fallmanagement
                    </router-link>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12"
                       v-if="
                      companySettings.privateLearningCoachingEnabled && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_SITE_SUPPORT' ||
                      currentUserRole === 'ROLE_SITE_MANAGER' ||
                      currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                      currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'coachAppointmentEvaluationPrivateLearningCoaching'}">
                      Private Weiterbildung
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!---------- BILLING ------------>
            <div v-if="
              (
                  companySettings.privateCoachingEnabled ||
                  companySettings.socioTherapyCoachingEnabled ||
                  companySettings.assistedLivingCoachingEnabled ||
                  companySettings.privateLearningCoachingEnabled
              ) && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' )">

              <h5 class="element-header mt-5">Rechnungslegung</h5>
              <div v-if="
              currentUserRole === 'ROLE_ADMIN' ||
              currentUserRole === 'ROLE_ACCOUNTANT'">
                <div class="pl-4">
                  <h6>Übersicht:</h6>
                  <div class="row" style="row-gap: 8px;">
                    <div
                        v-if=" companySettings.privateCoachingEnabled"
                        class="col-lg-3 col-md-4 col-sm-12">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsAccountingPrivateCoachingList'}">
                        Einzelcoaching
                      </router-link>
                    </div>
                    <div
                        v-if=" companySettings.socioTherapyCoachingEnabled"
                        class="col-lg-3 col-md-4 col-sm-12">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsAccountingSocioTherapyCoachingList'}">
                        Soziotherapie
                      </router-link>
                    </div>
                    <div
                        v-if=" companySettings.assistedLivingCoachingEnabled"
                        class="col-lg-3 col-md-4 col-sm-12">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsAccountingAssistedLivingCoachingList'}">
                        Betreutes Wohnen
                      </router-link>
                    </div>
                    <div
                        v-if=" companySettings.privateLearningCoachingEnabled"
                        class="col-lg-3 col-md-4 col-sm-12">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsAccountingPrivateLearningCoachingList'}">
                        Private Weiterbildung
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="
              (
                  companySettings.privateCoachingEnabled ||
                  companySettings.socioTherapyCoachingEnabled ||
                  companySettings.assistedLivingCoachingEnabled
              ) && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' )">
                <div class="pl-4 mt-4 pt-3" style="border-top: 1px solid #D8D8D8">
                  <h6>Prognose - Rechnungslegung:</h6>
                  <div class="row" style="row-gap: 8px;">
                    <div class="col-lg-3 col-md-4 col-sm-12" v-if="
                                companySettings.privateCoachingEnabled && (
                                currentUserRole === 'ROLE_ADMIN' ||
                                currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                                currentUserRole === 'ROLE_PERSONAL' ||
                                currentUserRole === 'ROLE_HEAD_OF_HR' ||
                                currentUserRole === 'ROLE_ACCOUNTANT' )">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsBillingForecastPrivateCoachingList'}">
                        Einzelcoaching
                      </router-link>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-12" v-if="
                                companySettings.socioTherapyCoachingEnabled && (
                                currentUserRole === 'ROLE_ADMIN' ||
                                currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                                currentUserRole === 'ROLE_PERSONAL' ||
                                currentUserRole === 'ROLE_HEAD_OF_HR' ||
                                currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                                currentUserRole === 'ROLE_ACCOUNTANT' )">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsBillingForecastSocioTherapyCoachingList'}">
                        Soziotherapie
                      </router-link>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-12" v-if="
                                companySettings.assistedLivingCoachingEnabled && (
                                currentUserRole === 'ROLE_ADMIN' ||
                                currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                                currentUserRole === 'ROLE_PERSONAL' ||
                                currentUserRole === 'ROLE_HEAD_OF_HR' ||
                                currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                                currentUserRole === 'ROLE_ACCOUNTANT' )">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsBillingForecastAssistedLivingCoachingList'}">
                        Betreutes Wohnen
                      </router-link>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-12" v-if="
                                currentUserRole === 'ROLE_ADMIN' ||
                                currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                                currentUserRole === 'ROLE_PERSONAL' ||
                                currentUserRole === 'ROLE_HEAD_OF_HR' ||
                                currentUserRole === 'ROLE_ACCOUNTANT' ">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsBillingForecastTotalValues'}">
                        Summen
                      </router-link>
                    </div>
                  </div>
                </div>

                <div class="pl-4 mt-4 pt-3" style="border-top: 1px solid #D8D8D8"
                     v-if="
                     companySettings.privateCoachingEnabled && (
                      currentUserRole === 'ROLE_ADMIN' ||
                      currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                      currentUserRole === 'ROLE_PERSONAL' ||
                      currentUserRole === 'ROLE_HEAD_OF_HR' ||
                      currentUserRole === 'ROLE_ACCOUNTANT' )">
                  <h6>Prognose - Externe Coachabrechnung:</h6>
                  <div class="row">
                    <div class="col">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsCoachBillingForecastPrivateCoachingList'}">
                        Einzelcoaching
                      </router-link>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!---------- COMPLETED COACHINGS ------------>
            <div v-if="
                 (companySettings.privateCoachingEnabled || companySettings.privateCoachingEnabled) && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' )">
              <h5 class="element-header mt-5">Durchgeführte Coachings</h5>

              <div class="pl-4">
                <h6>Übersicht:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div
                      v-if="companySettings.privateCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsFinishedPrivateCoachingList'}">
                        Einzelcoaching
                      </router-link>
                  </div>
                  <div
                      v-if="companySettings.assistedLivingCoachingEnabled"
                      class="col-lg-3 col-md-4 col-sm-12">
                      <router-link
                          class="link-primary-color"
                          :to="{name: 'analyticsFinishedAssistedLivingCoachingList'}">
                        Betreutes Wohnen
                      </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!---------- ACTIVE TRAINER HISTORY ------------>
            <div v-if="
                  companySettings.assistedLivingCoachingEnabled && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING'  ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' )">
              <h5 class="element-header mt-5">Aktive Trainergeschichte</h5>
              <div class="pl-4">
                <h6>Übersicht:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div class="col">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsActiveCoachingHistoryAssistedLivingCoachingList'}">
                      Betreutes Wohnen
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!---------- UNITS COMPLETED BY EXTERNAL TRAINERS ------------>
            <div v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING'  ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' ">

              <h5 class="element-header mt-5">Absolvierte Einheiten durch externe Trainer</h5>
              <div class="pl-4">
                <h6>Übersicht:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div class="col">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsUnitsDoneByExternalCoachesPerWeek'}">
                      Absolvierte Einheiten durch externe Trainer
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!---------- MONTHLY ATTENDANCE LIST ------------>
            <div v-if="
                  companySettings.assistedLivingCoachingEnabled && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' )">
              <h5 class="element-header mt-5">Anwesenheitsliste monatlich</h5>
              <div class="pl-4">
                <h6>Übersicht:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div class="col">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsMonthlyListAssistedLivingCoaching'}">
                      Betreutes Wohnen
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!---------- RETROSPECTIVE ------------>
            <div v-if="
                  companySettings.assistedLivingCoachingEnabled && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' ||
                  currentUserRole === 'ROLE_PERSONAL' ||
                  currentUserRole === 'ROLE_HEAD_OF_HR' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' )">
              <h5 class="element-header mt-5">Retrospektive</h5>
              <div class="pl-4">
                <h6>Übersicht:</h6>
                <div class="row" style="row-gap: 8px;">
                  <div class="col">
                    <router-link
                        class="link-primary-color"
                        :to="{name: 'analyticsRetrospectiveAssistedLivingCoaching'}">
                      Betreutes Wohnen
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <FormSidebar/>
    </div>
  </div>
</template>

<script setup>
import FormSidebar from '@/components/FormSidebar.vue';
import {piniaUserStore} from '@/store/piniaUserStore';
import {computed} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
</script>
<style scoped>
.element-box h5.element-header {
  font-weight: 600;
  letter-spacing: 0.2px;
}

.element-box h6 {
  color: #64748b;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 14px;
}

.element-box .row {
  row-gap: 10px;
}

.element-box a.link-primary-color {
  display: inline-flex;
  align-items: center;
  padding: 6px 4px;
  color: #495057;
  font-weight: 500;
  transition: color 0.15s ease;
}

.element-box a.link-primary-color::before {
  content: '';
  width: 3px;
  height: 14px;
  margin-right: 10px;
  border-radius: 2px;
  background: var(--primary);
  flex-shrink: 0;
  transition: height 0.15s ease;
}

.element-box a.link-primary-color:hover {
  color: var(--primary);
  text-decoration: none;
}

.element-box a.link-primary-color:hover::before {
  height: 18px;
}
</style>
  